export default {
	name: '',
	sprints: [],
	sprintsToKeep: 50,

	autoSprintTemplate: {
		name: 'Sprint {1}',
		phases: [{
			offset: {value: 1, unit: '-w'},
			name: 'Backlog review',
			color: '444',
			type: 'milestone'
		}, {
			offset: {value: 0, unit: '0'},
			name: 'Development',
			color: 'acf',
			type: 'normal'
		}, {
			offset: {value: 2, unit: 'w'},
			name: 'UAT',
			color: 'f9a',
			type: 'normal'
		}, {
			offset: {value: 3, unit: 'w'},
			name: 'Production',
			color: 'aea',
			type: 'normal'
		}],
		endOffset: {value: 5, unit: 'w'}
	},

	autoSprintEveryDays: {value: 2, unit: 'w'},
	autoSprintDaysAhead: {value: 4, unit: 'w'}
};
